import { render, staticRenderFns } from "./AoWriterDataTable.vue?vue&type=template&id=01ea3ac4&"
import script from "./AoWriterDataTable.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AoWriterDataTable.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports